export const OIDC_LOGIN = 'OIDC_LOGIN';
export const OIDC_LOGIN_REQUEST = 'OIDC_LOGIN_REQUEST';
